import { render, staticRenderFns } from "./Maintenance-History.vue?vue&type=template&id=9561634a&"
import script from "./Maintenance-History.vue?vue&type=script&lang=ts&"
export * from "./Maintenance-History.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports